import { useState } from "react";
import { fetchDocuments } from "../../utils/patients/documents/fetchDocuments";
import { uploadDocument } from "../../utils/patients/documents/uploadDocument";
import { downloadDocument } from "../../utils/patients/documents/downloadDocument";
import useProfileStore from "../../store/patient/profileStore";


const useManageDocuments = () => {

  const [loading, setLoading] = useState(false);
  const [documents, setDocuments ] = useState();
  const [downloadState, setDownloadState] = useState(false);
  const {profile} = useProfileStore()
  

  const handleFetchDocuments = async () => {
    try{
      setLoading(true);
      const response = await fetchDocuments(profile?.id)
      
      setDocuments(response.data);
      console.log(response.data)
      setLoading(false);

    } catch(err) {
      console.error(err)
      setLoading(false)
      window.location.href = "/pages/signin2";
      console.log("error error");
    }
    
  };

  const handleUploadDocument = async (id, document) => {
    try{
      setLoading(true);
      const response = await uploadDocument(id, document)
      return response

    } catch(err) {
      console.log(err)
      setLoading(false)
    }
    
  };


  //download-document
    const handleDownloadDocument = async (patient_id, doc_id) => {
        try{
            setDownloadState(true);
            const response = await downloadDocument(patient_id, doc_id)
            console.log(response)
        return response

        } catch(err) {
            console.log(err)
            window.location.href = "/pages/signin2";
            console.log("error error");
            setDownloadState(false)
            localStorage?.setItem("user", null)
        }
    };



  return {
    handleFetchDocuments,
    handleUploadDocument,
    handleDownloadDocument,
    downloadState,
    loading,
    documents,
  };
};

export default useManageDocuments;